import { IUserSkill } from "@common/microservice-types/db/skill/skill.user";
import { BehaviorSubject, Observable } from "rxjs";

export class ChatSkillStore
{
    private readonly skills$ = new BehaviorSubject<IUserSkill[]>([]);
    private storedSkills: IUserSkill[] = [];

    constructor(
        private readonly persistSkills: (skills: IUserSkill[]) => void,
    ) { }

    public $getSkills(): Observable<IUserSkill[]>
    {
        return this.skills$.asObservable();
    }

    public getStoredSkills(): IUserSkill[]
    {
        return [ ...this.storedSkills ];
    }

    public isDefaultSkill(skill: IUserSkill | null): boolean
    {
        return skill?.defaultSkillId != null;
    }

    public setSkills(skills: IUserSkill[]): IUserSkill[]
    {
        return this.setStoredSkills(skills);
    }

    public setStoredSkills(skills: IUserSkill[], persist = true): IUserSkill[]
    {
        this.storedSkills = [ ...skills ];
        this.skills$.next([ ...skills ]);

        if (persist)
        {
            this.persistSkills(this.storedSkills);
        }

        return this.skills$.getValue();
    }
}
